import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
	grid-column: 1 / -1;
	display: flex;
	justify-content: flex-end;
	gap: 24px;
	width: 100%;
	margin-top: 20px;
`;

export const SearchBar = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px;
`;

export const GridForm = styled.form`
	display: grid;
	grid-template-columns: auto auto;
	gap: 20px;
`;

export const Title = styled.h3`
	color: ${Colors.darkBlue};
`;

export const LogEntry = styled.div`
	margin-bottom: 1rem;
`;

export const LogMeta = styled.div`
	color: ${Colors.darkBlue};
	font-size: 0.8rem;
`;
